import React, { useState, useEffect } from 'react'
import { useFetch } from '../../../../../../hooks'
import { Card } from '../../../../../../components/Card'
import Table from '../../../../../../components/Table'
import Icon from '../../../../../../components/Icon'
import Button from '../../../../../../components/inputs/Button'
import Buttons from '../../../../../../modules/Buttons'
import { StyledData, StyledTime } from './styled'
import InfoBar from '../../../../../../modules/InfoBar'

const Heats = ({ grpid, infoBar, heats }) => {
    const { doFetch } = useFetch({
        url: '/rpc/get_heats_detected',
        method: 'POST',
        state: false
    })

    const [data, setData] = useState([]);
    const [nextID, setNextID] = useState();

    useEffect(() => {
        if (heats && heats.table) {
            setData(heats.table.data || [])
            setNextID(heats.table.nextid)
        }
    }, [heats])

    const handleClickNextID = async () => {
        try {
            const res = await doFetch({
                data: {
                    row_id: grpid,
                    nextid: nextID
                }
            })
            if (res.data) {
                setData(prevData => [...prevData, ...res.data])
            }
            setNextID(res.nextid)
        } catch (err) {
            console.log(err)
        }
    }


    return (
        <>
            {
                infoBar &&
                <InfoBar
                    lastUpdate={infoBar.lastUpdate}
                    translation={infoBar.translation}
                    noContainer
                />
            }
            <Card>
                {
                    heats &&
                    <Table
                        columns={[{
                            name: heats.field1,
                            key: 'cow_no'
                        }, {
                            name: heats.field2,
                            key: 'detected',
                            cell: item => (
                                <>
                                    <StyledData>{item && item[0]}</StyledData>
                                    <StyledTime>{item && item[1]}</StyledTime>
                                </>
                            )
                        }, {
                            name: heats.field3,
                            key: 'window',
                            cell: item => (
                                <>
                                    <StyledData>{item && item[0]}</StyledData>
                                    <StyledTime>{item && item[1]}</StyledTime>
                                </>
                            )
                        }, {
                            cell: () => <Icon name='arrow' />,
                            style: {
                                maxWidth: '14px',
                                alignSelf: 'center',
                                marginRight: 0
                            }
                        }]}
                        data={data}
                        divider
                        minWidth={'280px'}
                        hover
                    />
                }
                {
                    nextID &&
                    <Buttons style={{ marginBottom: '-20px' }}>
                        <Button transparent green fullWidth noMargin style={{ padding: '20px 0' }} onClick={handleClickNextID}>{heats.footer}</Button>
                    </Buttons>
                }
            </Card>
        </>
    )
}

export default Heats
